import { ICartData } from "../../../../v2/app/Cart/types/ICartData";
import { IPromoResponseModel } from "../../../../v2/app/Cart/types/IPromoResponseModel";

import { ICartRowItem } from "../../../../v2/app/Cart/types/ICartRowItem";
import { AjaxPost, IAjaxPostConfig } from "../../../../v2/app/Services/index";
import { CartHeaders, CartItem } from "../../Cart/index";
import { UrlSegments } from "../../Helpers";

declare global {
    interface KnockoutExtenders {
        UpdateCartQty: (target: any, value: any) => KnockoutObservable<any>;
    }
}

export function UpdateCartQty(target: KnockoutObservable<any>, cartItem: CartItem) {
    target.subscribe(function (valueChange) {
        // Do not update if value less than zero
        if (parseInt(valueChange) < 0)
            return;

        let cartVM: Object = (<any>window).cartVM,
            header: CartHeaders = (<any>cartVM).header;

        console.debug("Cart Item to Update: ", cartItem);

        let originalValue = cartItem.QtyOrdered;

        let item: ICartRowItem = {
            OrderItemRecNo: cartItem.OrderItemRecNo,
            CartOrderID: cartItem.CartOrderID,
            ItemID: cartItem.ItemID,
            UoMPackSize: cartItem.UoMPackSize,
            UoM: cartItem.UoMDesc + "-" + cartItem.UoMPackSize,
            QtyOrdered: parseInt(valueChange),
            
        };

        let ajaxConfig: IAjaxPostConfig = {
            endpoint: '/ShoppingCart/EditCart',
            payload: JSON.stringify({
                item: item,
                action: "update"
            }),

            cbFunction: function (response: ICartData) {
                let error = response.Messages.split(':')[0] === 'Error';
                let errorMsg = "";
                let msgBody = "";
                
                if (error) {
                    switch (response.Messages.split(':')[1].trim()) {
                        //we should not match on strings, that split might not give the desired results,
                        ////for "quota exceeded" there is an empty starting space!
                        case "Quota Exceeded":                            
                            errorMsg = "The quantity you have selected to add to your cart exceeds the quota set by your administrator.";
                            break;
                        case "OnlySupplyList":                            
                            errorMsg = "Error: Only items on supply list are allowed";
                            break;
                        default:                            
                            errorMsg = "Error:"+response.Messages.split(':')[1]
                            break;
                    }
                }

                console.debug("EditCart server response: ", response);

                let container = $(".floating-alert-container");
                let template = container.find('.alert').first();
                let msgAlert = template.clone();

                if (error) {

                    if (UrlSegments(0) === "ShoppingCart") {
                        console.debug("Item original quantity: ", originalValue);
                        target(originalValue);
                    }

                    msgBody = errorMsg;
                    
                    msgAlert.removeClass('alert-success');
                    msgAlert.addClass('alert-danger');

                    msgAlert.find('span').first().text(msgBody);

                    msgAlert.insertBefore(template).show();
                    let messageTally = container.find('.alert').length;

                    if (messageTally > 5) {
                        $(msgAlert).alert('close');
                        $(msgAlert).remove();
                    }

                    setTimeout(function () {
                        $(msgAlert).alert('close');
                        $(msgAlert).remove();
                    }, 5000);

                } else {                    
                    header.ParseCartData(response);
                    let requestID = header.UpdateRequestID();
                                                            
                }

                
            }

        };

        new AjaxPost(ajaxConfig);
    });

    return target;


}

let updateCartQty = ko.extenders.UpdateCartQty = UpdateCartQty;
export default updateCartQty;